module.exports = __webpack_public_path__ + "images/goodsGroup.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goodsGroup.png
// module id = 959
// module chunks = 2